import { BookOpen, Sparkles, Leaf } from "lucide-react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const Login = () => {
  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + '/app';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-[#F8F6F1] flex items-center justify-center p-8 relative overflow-hidden">
      <Link to="/" className="absolute top-6 left-6 z-20 flex items-center gap-2 group" data-testid="home-button">
        <div className="w-8 h-8 rounded-full bg-gradient-to-br from-[#9FB89F] to-[#7A9B7E] flex items-center justify-center group-hover:shadow-md transition-shadow">
          <Leaf className="w-4 h-4 text-white" />
        </div>
        <span className="font-serif text-lg font-medium text-[#2D3A2D]">My Story</span>
      </Link>
      <div className="absolute top-20 right-20 w-96 h-96 bg-[#9FB89F]/10 organic-blob" />
      <div className="absolute bottom-20 left-20 w-64 h-64 bg-[#E5D4C1]/15 organic-blob" style={{ animationDelay: '2s' }} />
      
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        className="relative z-10 max-w-md w-full"
      >
        <div className="bg-white/80 backdrop-blur-sm border-2 border-[#D4C9B8]/40 rounded-3xl p-12 shadow-2xl">
          <div className="flex justify-center mb-8">
            <div className="w-20 h-20 rounded-full bg-gradient-to-br from-[#9FB89F] to-[#7A9B7E] flex items-center justify-center organic-blob shadow-lg">
              <Leaf className="w-10 h-10 text-white" />
            </div>
          </div>
          
          <h1 className="font-serif font-bold text-4xl text-[#4A5D4A] text-center mb-3">
            My Story
          </h1>
          <p className="font-sans text-[#7A8A7A] text-center mb-8">
            Create your beautiful AI-powered memoir
          </p>
          
          <div className="space-y-3 mb-8">
            <div className="flex items-center gap-3 text-[#5A7B5E]">
              <Sparkles className="w-5 h-5 flex-shrink-0" />
              <span className="font-sans text-sm">AI-organized life chapters</span>
            </div>
            <div className="flex items-center gap-3 text-[#5A7B5E]">
              <BookOpen className="w-5 h-5 flex-shrink-0" />
              <span className="font-sans text-sm">Beautiful memoir book layout</span>
            </div>
            <div className="flex items-center gap-3 text-[#5A7B5E]">
              <Leaf className="w-5 h-5 flex-shrink-0" />
              <span className="font-sans text-sm">Voice conversation supported</span>
            </div>
          </div>
          
          <button
            onClick={handleLogin}
            className="w-full bg-gradient-to-r from-[#7A9B7E] to-[#6A8B6E] text-white py-4 px-6 rounded-full font-sans font-medium text-lg hover:shadow-lg hover:-translate-y-0.5 transition-all duration-200"
            data-testid="google-login-button"
          >
            Sign in with Google
          </button>
          
          <p className="font-sans text-xs text-[#8A7A6A] text-center mt-6">
            Your stories are private and secure
          </p>
        </div>
      </motion.div>
    </div>
  );
};

export default Login;
